import { Link, isRouteErrorResponse, useRouteError } from "react-router";

/** What a page shows when it breaks, or when there is no such page: plain
 *  words and a way on, never the framework's developer screen. */
export function Problem() {
  const error = useRouteError();
  const missing = isRouteErrorResponse(error) && error.status === 404;
  if (!missing) console.error(error);
  return (
    <div className="mx-auto flex min-h-dvh max-w-xl flex-col items-start justify-center gap-4 px-4">
      <span className="orb" aria-hidden="true" />
      <h1 className="text-[clamp(28px,4vw,40px)]">{missing ? "There's no page here" : "Something went wrong on this page"}</h1>
      <p className="text-ink-2">{missing ? "The link may be old, or mistyped." : "It's not you. Reload the page, and if it happens again, try later."}</p>
      <div className="flex flex-wrap gap-3">
        {!missing && <button className="btn btn-primary" onClick={() => location.reload()}>Reload</button>}
        <Link to="/" className={missing ? "btn btn-primary" : "btn"}>Go to the home page</Link>
      </div>
    </div>
  );
}
